import { layoutWorkspace } from './../_common/layout.workspace';
import { DashboardScreen } from './screens.dashboard';
import { ConfigSection } from '@components-fabric';

/**
 * Configuration Object: lecturersAreaScreens
 * 
 * This object contains the configuration for the lecturers area screens.
 * It includes roles, layout, and screen configurations.
 */
export const lecturersAreaScreens: ConfigSection = {
  id: 'lecturers',
  layout: layoutWorkspace,
  tmp: 'index',
  path: 'lecturers',
  screens: [
    {
      id: 'dashboard',
      path: '',
      roles: ['STUDY_DIRECTOR', 'LECTURER'],
      Component: DashboardScreen,
    },
  ],
};
